import ErrorBoundary from './ErrorBoundary.js';

export default ErrorBoundary;
